import { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { listDemandConversations } from '../lib/communicationsStore.js';
import {
  isConversationUnread,
  loadInboxSeenMap,
} from '../lib/messagesInbox.js';

export default function HeaderMessagesButton({ matters = [], viewer = {} }) {
  const unreadCount = useMemo(() => {
    const seenMap = loadInboxSeenMap();
    const threads = listDemandConversations(matters);
    let count = 0;
    for (const thread of threads) {
      if (isConversationUnread(thread, viewer, seenMap)) count += 1;
    }
    return count;
  }, [matters, viewer]);

  const label =
    unreadCount > 0
      ? `Messages, ${unreadCount} unread conversation${unreadCount === 1 ? '' : 's'}`
      : 'Messages';

  return (
    <NavLink
      to="/client/messages"
      className={({ isActive }) =>
        `header-messages-btn${isActive ? ' is-active' : ''}${
          unreadCount > 0 ? ' has-unread' : ''
        }`
      }
      aria-label={label}
      title={label}
    >
      <MailIcon />
      {unreadCount > 0 ? (
        <span className="header-messages-badge" aria-hidden="true">
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      ) : null}
    </NavLink>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 28" width="22" height="26" aria-hidden="true">
      <path
        d="M4 6.5h16a1.5 1.5 0 0 1 1.5 1.5v12A1.5 1.5 0 0 1 20 21.5H4A1.5 1.5 0 0 1 2.5 20V8A1.5 1.5 0 0 1 4 6.5Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path
        d="m4 8.25 8 6 8-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
